import { useState } from "react";
import { ErrorMessage, useFormikContext } from "formik";
import {
  VIPSDataServiceURL,
  requestOptions,
} from "../../Constants/GlobalConstant";
import { getMessage } from "../../CommonFuntion/messages";
import SnackbarAlert from "./SnackbarAlert";
import { titleCase } from "../../CommonFuntion/SchemaValidation";
import {
  applyMaskOnBlur,
  MASK_BLUR_STRATEGY,
} from "../../CommonFuntion/applyMaskOnBlur";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import FormControl from "@mui/material/FormControl";
import { styled } from "@mui/material/styles";

const CssTextField = styled(TextField)({});
const CatalogueOutTableTextboxField = (props) => {
  const [validOrderMessage, setvalidOrderMessage] = useState("");
  const [openToolbar, setOpenToolbar] = useState(false);
  const handleCloseToolbar = () => {
    setOpenToolbar(false);
  };
  const {
    name,
    lastKey,
    catId,
    catDropDown,
    schemaResult,
    keyIndex,
    SetcatalogueChildOptn,
    user_id,
    store_grp,
    label,
    tagName,
    validation = {}, // added default to avoid undefined access
    prefix,
  } = props;
  var itemID = schemaResult[1].itemId;
  const { setFieldValue, values } = useFormikContext();
  const id = `${tagName}-input`;
  const textboxChange = (e) => {
    const rawValue = e.target.value;
    const { nextValue } = applyMaskOnBlur(rawValue, validation?.pictureMask, {
      strategy: MASK_BLUR_STRATEGY.CATALOGUE,
    });
    const value = nextValue;
    if (value.length > 0) {
      setFieldValue(name, value);
      if (lastKey === true) {
        if (value) {
          let changeDropDownVal = { ...catDropDown };
          changeDropDownVal[keyIndex] = value;
          let getCatalogueHeaderDataApiUrl =
            `${VIPSDataServiceURL}/Catalogue/GetCatalogueDetailData?catId=${catId}` +
            `&pageID=${itemID}`;
            const entriesDropDown = Object.entries(changeDropDownVal);
          entriesDropDown?.forEach(([key, value]) => {
            getCatalogueHeaderDataApiUrl =
              getCatalogueHeaderDataApiUrl + `&key${parseInt(key)}=${value}`;
          });
          getCatalogueHeaderDataApiUrl =
            getCatalogueHeaderDataApiUrl +
            `&storeGrp=${store_grp}` +
            `&userId=${user_id}`;
          fetch(getCatalogueHeaderDataApiUrl, requestOptions)
            .then((response) => response.json())
            .then((data) => {
              if (data.catData.length > 0) {
                if (data.errorCode === 0) {
                  SetcatalogueChildOptn(data.catData);
                }
              } else if (data.errorCode === 1) {
                setvalidOrderMessage(data.errorDescription);
                setOpenToolbar(true);
                SetcatalogueChildOptn("");
                setFieldValue(name, "");
              } else {
                setvalidOrderMessage(getMessage("validData"));
                setOpenToolbar(true);
                SetcatalogueChildOptn("");
                setFieldValue(name, "");
              }
            });
        }
      }
    } else {
      SetcatalogueChildOptn("");
    }
  };
  const handleChange = (e) => {
    setFieldValue(name, e.target.value);
  };
  return (
    <>
      <div className="flex-container">
        <div className="control-bottom-border">
          {label && (
            <label className="font-css" htmlFor={id}>
              {titleCase(label.replace("_", " "))}
              {validation?.mandatory && (
                <span className="mandatory-validation">{"*"}</span>
              )}
            </label>
          )}
        </div>
        <div className="control-bottom-border">
          <FormControl>
            <Tooltip
              title={
                validation?.pictureMask
                  ? "Picture Mask:" + validation.pictureMask.replace(/"/g, "")
                  : ""
              }
            >
              <CssTextField
                id={id}
                inputProps={{
                  maxLength: validation?.pictureMask?.length
                    ? validation?.pictureMask?.replace(/"/g, "").length
                    : "",
                }}
                type="text"
                name={name}
                key={name}
                tagname={tagName}
                prefix={prefix}
                fullWidth
                placeholder=""
                style={{
                  fontSize: "12px",
                  width: "200px",
                }}
                onChange={handleChange}         
                onBlur={textboxChange}          
                variant="standard"
                value={values?.[name] || ""}
              />
            </Tooltip>
          </FormControl>
          <ErrorMessage
            name={name}
            render={(msg) => <div className="is-invalid">{msg}</div>}
          />
        </div>
      </div>
      <SnackbarAlert
        open={openToolbar}
        message={validOrderMessage}
        severity="error"
        onClose={handleCloseToolbar}
      />
    </>
  );
};

export default CatalogueOutTableTextboxField;
